<eo-file-upload-base
  [id]="id"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [config]="getConfig()"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <div class="flex gap-1">
    <p-button
      *ngIf="files.length > 0"
      type="button"
      [icon]="getCancelIcon"
      [label]="getCancelLabel"
      [styleClass]="getCancelStyleClass"
      [disabled]="loading"
      (onClick)="onFileRemove()"
    />
    <p-fileUpload
      *ngIf="files.length === 0"
      name="files{{ id }}[]"
      mode="basic"
      [showUploadButton]="false"
      [files]="files"
      [styleClass]="styleClass"
      [chooseLabel]="getChooseLabel"
      [chooseIcon]="getChooseIcon"
      [multiple]="getMultiple"
      [accept]="getAccept"
      [maxFileSize]="getMaxFileSize"
      [fileLimit]="getFileLimit"
      (onSelect)="onFilesSelect($event)"
      (onRemove)="onFileRemove($event)"
    />
    <input
      class="w-full {{ inputStyleClass }}"
      type="text"
      pInputText
      disabled
      tooltipPosition="top"
      [value]="getFilenamesString()"
      [pTooltip]="inputTooltip"
    />
    <ng-template #inputTooltip>
      <div>
        <ul class="w-full ui-tooltip-text" style="width: 1000px">
          <li *ngFor="let fileName of getFilenamesArray()">{{ fileName }}</li>
        </ul>
      </div>
    </ng-template>

    <a
      pButton
      *ngIf="getDownloadPrototypeVisible"
      icon="pi pi-file-arrow-up"
      pTooltip="Λήψη Προτότυπου"
      class="p-button-outlined p-button-success p-2 px-3"
      [href]="config?.prototypeUrl"
      target="_blank"
    ></a>

    <a
      pButton
      *ngIf="showDownloadFile()"
      icon="pi pi-download"
      pTooltip="Λήψη αρχείου"
      class="p-button-outlined p-button-success p-2 px-3"
      [href]="formControl.value[0]?.FileUrl"
      target="_blank"
    ></a>
  </div>
</eo-file-upload-base>
